/**
 * Map FlowchartCanvas props to NodeRenderer props (including quick-view handlers).
 */
export default function buildNodeRendererProps(props, { quickView, onNavigateToParentMission }) {
  const {
    tasks,
    tasksToRender,
    fullNodeIds = null,
    statuses,
    positionsToUse,
    nodeDimensions,
    selectedNodes,
    draggingNode,
    connectingFrom,
    connectingTarget,
    connectingBranch,
    isConnecting,
    focusedTaskIds,
    isAnimatingLayout,
    isFocusMode,
    lockStates,
    allCategories,
    allTags,
    nestedSprints,
    allSprints,
    containerRef,
    pan,
    zoom,
    viewportSize,
    dropTarget,
    layoutSurfaceEpoch,
    getNodeAnimationState,
    handleNodeDragStart,
    handleNodeClick,
    handleConnectionDragStart,
    handleCreateConnectedNode,
    hasClipboardData,
    handleFocusTask,
    centerOnTask,
    handleDimensionsChange,
    onRenameTask,
    onStatusChange,
    onCategoryChange,
    onAddTag,
    onRemoveTag,
    onSetPrimaryTag,
    onIconChange,
    onIconDeleted,
    onTaskResize,
    onTaskResizeEnd,
    onTaskResetSize,
    onDecisionAnswerChange,
    onDecisionOptionsChange,
    onDeleteTask,
    onOpenNestedSprint,
    onCreateNestedSprint,
    onRemoveNestedSprint,
    onDeliverablesChange,
    onInputsChange,
    onOpenDetails,
    onOpenAttachments,
    onAddStatus,
    onDeleteStatus,
    onRenameStatus,
    onSetStatusAutoSync,
    onRenameCategory,
    onDeleteCategory,
    onRenameTag,
    onDeleteTag,
    onDueDateChange,
    onRemindersChange,
    onEstimatedDurationMinutesChange,
    onCreatedAtChange,
    onStartedAtChange,
    onCompletedAtChange,
    onUpdatedAtChange,
    onPriorityChange,
    onDifficultyChange,
    onCustomFieldValueChange,
    customFields,
    onArchiveTask,
    onUnarchiveTask,
    onDependencyChange,
    onConditionsChange,
    onMilestoneAnchorChange,
    onAddMilestoneOnHost,
    onAddNoteOnHost,
    onCreateParallelMission,
    onInsertMissionBefore,
    onConditionsDialogOpen,
    onConditionsDialogClose,
    onCopy,
    onDuplicate,
    cardDisplaySettings,
    isTemplate,
    isMultiCampaignMode,
    currentView,
    customViews,
    activeCustomViewId,
    onViewChange,
    onSelectCustomView,
    onGoToTaskInView,
    onExplodeNestedCampaign,
    hoveredMissionId,
    onMissionHover,
    onMissionLeave,
    onSubmitDeliverable,
    onEditDeliverables,
    onClearDeliverable,
  } = props;

  return {
    tasks: tasksToRender,
    fullNodeIds,
    statuses,
    positionsToUse,
    nodeDimensions,
    selectedNodes,
    draggingNode,
    connectingFrom,
    connectingTarget,
    connectingBranch,
    isConnecting,
    focusedTaskIds,
    isAnimatingLayout,
    isFocusMode,
    lockStates,
    allCategories,
    allTags,
    allTasks: tasks,
    nestedSprints,
    allSprints,
    containerRef,
    pan,
    zoom,
    viewportSize,
    dropTarget,
    layoutSurfaceEpoch,
    getNodeAnimationState,
    handleNodeDragStart,
    handleNodeClick,
    handleConnectionDragStart,
    handleCreateConnectedNode,
    hasClipboardData,
    handleFocusTask,
    centerOnTask,
    handleDimensionsChange,
    onRenameTask,
    onStatusChange,
    onCategoryChange,
    onAddTag,
    onRemoveTag,
    onSetPrimaryTag,
    onIconChange,
    onIconDeleted,
    onTaskResize,
    onTaskResizeEnd,
    onTaskResetSize,
    onDecisionAnswerChange,
    onDecisionOptionsChange,
    onDeleteTask,
    onOpenNestedSprint,
    onCreateNestedSprint,
    onRemoveNestedSprint,
    onDeliverablesChange,
    onInputsChange,
    onOpenDetails,
    onOpenAttachments,
    onAddStatus,
    onDeleteStatus,
    onRenameStatus,
    onSetStatusAutoSync,
    onRenameCategory,
    onDeleteCategory,
    onRenameTag,
    onDeleteTag,
    onDueDateChange,
    onRemindersChange,
    onEstimatedDurationMinutesChange,
    onCreatedAtChange,
    onStartedAtChange,
    onCompletedAtChange,
    onUpdatedAtChange,
    onPriorityChange,
    onDifficultyChange,
    onCustomFieldValueChange,
    customFields,
    onArchiveTask,
    onUnarchiveTask,
    onDependencyChange,
    onConditionsChange,
    onMilestoneAnchorChange,
    onAddMilestoneOnHost,
    onAddNoteOnHost,
    onCreateParallelMission,
    onInsertMissionBefore,
    onConditionsDialogOpen,
    onConditionsDialogClose,
    onCopy,
    onDuplicate,
    cardDisplaySettings,
    isTemplate,
    isMultiCampaignMode,
    onQuickViewMouseEnter: quickView.handleQuickViewMouseEnter,
    onQuickViewMouseLeave: quickView.handleQuickViewMouseLeave,
    onQuickViewMouseMove: quickView.handleQuickViewMouseMove,
    currentView,
    customViews,
    activeCustomViewId,
    onViewChange,
    onSelectCustomView,
    onGoToTaskInView,
    onExplodeNestedCampaign,
    hoveredMissionId,
    onMissionHover,
    onMissionLeave,
    onSubmitDeliverable,
    onEditDeliverables,
    onClearDeliverable,
    onNavigateToParentMission,
  };
}
